var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8061_2624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.54 0C5.16671 0 0 5.16671 0 11.54C0 16.9519 3.72605 21.4931 8.75243 22.7403V15.0667H6.37287V11.54H8.75243V10.0204C8.75243 6.09268 10.5301 4.27212 14.3863 4.27212C15.1175 4.27212 16.379 4.41568 16.8951 4.55878V7.75537C16.6227 7.72675 16.1496 7.71244 15.562 7.71244C13.6699 7.71244 12.9387 8.42931 12.9387 10.2928V11.54H16.7081L16.0605 15.0667H12.9387V22.9956C18.6529 22.3055 23.0805 17.4402 23.0805 11.54C23.0801 5.16671 17.9134 0 11.54 0Z",
    fill: "#C5CBDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8061_2624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.0801,
    height: 23.0801,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.507ec6dfed6d363038942dd82cd3e142.svg";
export { ForwardRef as ReactComponent };